<template>
  <div class="ibox">
    <div class="ibox-title">
      <strong>Add / Edit Commodity</strong>
    </div>
    <div class="ibox-footer ibox-footer-edit-commodity" style="padding-top: 15px">
        <div class="row">
          <div class="col-xs-6 col-sm-4 col-md-4" :class="{'col-lg-4': creatingNewCommodity, 'col-lg-2': editingExistingCommodity}">
            <div class="form-group-outer">
              <div class="form-group float-label-control" :class="{ 'has-error': errors.has('name') }">
                <label for="" class="select-label">Commodity Name</label>
                <div class="input-group">
                  <input type="text" v-model="commodity.name" class="form-control" placeholder="Commodity Name" v-validate="'required'" name='name'/>
                </div>
              </div>
            </div>
          </div>
          <div class="col-xs-6 col-sm-4 col-md-4 col-lg-2">
            <div class="form-group-outer form-group-outer-description">
              <div class="form-group float-label-control">
                <label for="" class="select-label">Charge Type</label>
                <selectize
                  v-model="commodity.charge_type"
                  name="chargeType"
                  :options="chargeTypeOptions">
                </selectize>
              </div>
            </div>
          </div>
          <div class="col-xs-6 col-sm-4 col-md-4 col-lg-2">
            <div class="form-group-outer form-group-outer-description">
              <div class="form-group float-label-control">
                <label for="" class="select-label">Common</label>
                <selectize
                  v-model="commodity.common"
                  name="common"
                  :options="commonOptions">
                </selectize>
              </div>
            </div>
          </div>
          <div class="col-xs-6 col-sm-4 col-md-4 col-lg-2">
            <div class="form-group-outer form-group-outer-description">
              <div class="form-group float-label-control">
                <label for="" class="select-label">Status</label>
                <selectize
                  v-model="commodity.status"
                  name="status"
                  :options="statusOptions">
                </selectize>
              </div>
            </div>
          </div>
          <div class="col-xs-12 col-sm-4 col-md-4 col-lg-2">
            <ladda-button v-if="commodity.id" type="success" size="small" :max-width="true" :on-click="handleSaveCommodity" class="m-t-sm m-b-sm"><i class="fa fa-check"></i> Save</ladda-button>
            <ladda-button v-else :max-width="true" size="small" :on-click="handleSaveCommodity"  class="m-t-sm m-b-sm"><i class="fa fa-plus"></i> Add</ladda-button>
          </div>
          <div v-if="editingExistingCommodity" class="col-xs-12 col-sm-4 col-md-4 col-lg-2">
            <button class="btn btn-sm btn-danger btn-block m-t-sm m-b-sm" @click="clearCommodity"><i class="fa fa-times"></i> Cancel</button>
          </div>
        </div>
        <div class="row">
          <div class="col-xs-6 col-sm-4 col-md-4 col-lg-2">
            <div class="form-group">
								<label class="control-label">Show Archived</label>
								<div class="checkbox">
									<input id="check-archive" class="styled" type="checkbox" v-model="archived" />
									<label for="check-archive">
										Yes
									</label>
								</div>
							</div>
          </div>
        </div>
      </div><!-- /.ibox-footer -->
      <div class="ibox-content">
        <ul class="list-detail list-detail-commodity-types">
          <li v-for="commodity in commodities">
            <div class="row">
              <div class="col-xs-8 col-md-5">
                <p class="truncate">{{ commodity.name }}</p>
              </div>
              <div class="col-xs-4 col-md-2">
                <p class="text-charge-type">{{ commodity.charge_type}}</p>
              </div>
              <div class="col-xs-12 col-md-5">
                <div class="btn-toolbar pull-right" v-if="!commodity.deleted_at">
                  <span
                    class="status "
                    :class="{'status-enabled': commodity.status, 'status-disabled': !commodity.status}">
                    {{ commodity.status ? 'Enabled' : 'Disabled'}}
                  </span>

                  <a
                    @click="handleChangeCommon(commodity)"
                    class="btn btn-circle-sm"
                    :class="{'btn-success': commodity.common, 'btn-default': !commodity.common}">
                    <i
                      class="fa"
                      :class="{'fa-star': notChangingCommodity(commodity.id) && commodity.common,
                        'fa-star-o': notChangingCommodity(commodity.id) && !commodity.common,
                        'fa-circle-o-notch fa-spin': changingCommodity(commodity.id)
                      }">
                    </i>
                  </a>

                  <a
                    @click="handleArchive(commodity.id)"
                    class="btn btn-circle-sm btn-danger">
                    <i
                      class="fa"
                      :class="{'fa-archive': notArchivingCommodity(commodity.id), 'fa-circle-o-notch fa-spin': archivingCommodity(commodity.id)}">
                    </i>
                  </a>

                  <a
                    @click="handleEditCommodity(commodity)"
                    class="btn btn-circle-sm btn-info">
                    <i class="fa fa-pencil"></i>
                  </a>
                </div>
              </div>
            </div><!-- /.row -->
          </li>
        </ul>

        <div class="text-center text-muted" v-show="haveNoCommodities">
          <strong>There are no commodities.</strong>
        </div>
      </div><!-- /.ibox-content -->
  </div><!-- /.ibox -->
</template>

<script>
  import { Selectize, LaddaButton } from 'components/forms'
  import { mapActions, mapState } from 'vuex'
  import { cloneDeep, remove, find } from 'lodash'
  import notify from 'utils/notify'

  export default {
    data () {
      return {
        archiving: [],
        changing: [],
        commodity: {
          id: null,
          name: null,
          charge_type: 'delivery',
          common: true,
          status: 1
        },
        archived: false
      }
    },

    components: {
      Selectize,
      LaddaButton
    },

    created () {
      this.getCommodities({ status: 'all' })
    },

    watch: {
      archived (value) {
        if (value) {
          this.getCommodities({ status: 'archived' })
        } else {
          this.getCommodities({ status: 'all' })
        }
      }
    },

    computed: {
      ...mapState('commodity', ['commodities']),

      /**
       * Determine if we have no commodities.
       *
       * @return boolean
       */
      haveNoCommodities () {
        return this.commodities.length === 0
      },

      /**
       * Determine if editing an existing commodity.
       *
       * @return boolean
       */
      editingExistingCommodity () {
        return this.commodity.id !== null
      },

      /**
       * Determine if editing an creating a new commodity.
       *
       * @return boolean
       */
      creatingNewCommodity () {
        return this.commodity.id === null
      },

      /**
       * Charge type select box options.
       *
       * @return array
       */
      chargeTypeOptions () {
        return [
          { id: 'delivery', text: 'Delivery' },
          { id: 'pickup', text: 'Pickup' }
        ]
      },

      /**
       * Common select box options.
       *
       * @return array
       */
      commonOptions () {
        return [
          { id: true, text: 'Yes' },
          { id: false, text: 'No' }
        ]
      },

      /**
       * Status select box options.
       *
       * @return array
       */
      statusOptions () {
        if (this.commodity.id) {
          return [
            { id: 1, text: 'Enabled' },
            { id: 0, text: 'Disabled' },
            { id: 2, text: 'Archived' }
          ]
        } else {
          return [
            { id: 1, text: 'Enabled' },
            { id: 0, text: 'Disabled' }
          ]
        }
      }
    },

    methods: {
      ...mapActions('commodity', ['getCommodities', 'storeCommodity', 'updateCommodity', 'archiveCommodity']),

      /**
       * Determine if we are sending a request to archive a commodity for the given ID.
       *
       * @param integer id
       *
       * @return boolean
       */
      archivingCommodity (id) {
        return find(this.archiving, archiving => archiving === id) !== undefined
      },

      /**
       * Inverse of above.
       *
       * @param integer id
       *
       * @return boolean
       */
      notArchivingCommodity (id) {
        return !this.archivingCommodity(id)
      },

      /**
       * Determine if we are sending a request to change a commodity for the given ID.
       *
       * @param integer id
       *
       * @return boolean
       */
      changingCommodity (id) {
        return find(this.changing, changing => changing === id) !== undefined
      },

      /**
       * Inverse of above.
       *
       * @param integer id
       *
       * @return boolean
       */
      notChangingCommodity (id) {
        return !this.changingCommodity(id)
      },

      /**
       * Handle saving of a new or existing commodity.
       *
       * @return Promise
       */
      handleSaveCommodity () {
        const reportMissingNameError = () => {
          if (this.errors.has('name')) {
            notify.error('A commodity name is required.')
          }
        }

        const commodityHasBeenSaved = () => {
          notify.success('Commodity has been saved.')

          this.clearCommodity()

          this.$nextTick(() => (this.errors.clear()))

          if (this.archived) {
            this.archived = false
          }
        }

        return this.validateAll().then(() => {
          if (this.editingExistingCommodity) {
            return this.updateCommodity({ id: this.commodity.id, payload: this.commodity }).then(commodityHasBeenSaved)
          } else {
            return this.storeCommodity(this.commodity).then(commodityHasBeenSaved)
          }
        }).catch(reportMissingNameError)
      },

      /**
       * Handle editing a commodity.
       *
       * @param object commodity
       *
       * @return void
       */
      handleEditCommodity (commodity) {
        this.commodity = cloneDeep(commodity)
      },

      /**
       * Clear the currently selected commodity.
       *
       * @return void
       */
      clearCommodity () {
        this.commodity = {
          id: null,
          name: null,
          charge_type: 'delivery',
          common: true,
          status: 1
        }
      },

      /**
       * Handle changing the common property of the commodity.
       *
       * @param integer id
       * @param boolean common
       *
       * @return {[type]}
       */
      handleChangeCommon ({ id, common }) {
        if (this.changingCommodity(id)) {
          return
        }

        this.changing.push(id)

        const commodityHasBeenUpdated = () => {
          notify.success('Commodity has been updated.')

          remove(this.changing, changing => changing === id)

          return this.getCommodities({ status: 'all' })
        }

        return this.updateCommodity({ id, payload: { common: !common } }).then(commodityHasBeenUpdated)
      },

      /**
       * Handle archiving a commodity.
       *
       * @param integer id
       *
       * @return Promise
       */
      handleArchive (id) {
        if (this.archivingCommodity(id)) {
          return
        }

        this.archiving.push(id)

        const commodityHasBeenArchived = () => {
          notify.success('Commodity has been archived.')

          remove(this.archiving, archiving => archiving === id)

          return this.getCommodities({ status: 'all' })
        }

        return this.archiveCommodity(id).then(commodityHasBeenArchived)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// Commodities.vue?59579fca